import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import getIn from '../../components/connectedForm/utils/getIn.js';
import { MergeFieldCentre, MergeFieldDiv } from './MergeField';
import { IMergeConflict } from './MergeConflicts';

type IDisplayValueProps = {
  getDisplayValue: (value: any) => any;
  form: string;
  path: string;
  conflict: IMergeConflict;
};

const MergeChosenValue = ({ getDisplayValue, form, path }: IDisplayValueProps) => {
  const displayValue = useSelector((store: any) => getIn(store.newform?.[form]?.values, path));
  const value = getDisplayValue(displayValue);

  if (typeof value === 'object' && value !== null) {
    console.warn('Value is an object of an unsupported type', value);
    return null;
  }

  return (
    <MergeFieldDiv>
      <MergeFieldCentre>{value}</MergeFieldCentre>
    </MergeFieldDiv>
  );
};

export default memo(MergeChosenValue);
